module.exports = __webpack_public_path__ + "img/BetwixtThings.b6935d0b.png";